// constant
export const UPDATE_PROPS = "/projectList/UPDATE_PROPS";

// reducer
export const projectList = (state = {
  projectName: "",
  projectId: ""
}, action) => {
  switch (action.type) {
    case "/projectList/UPDATE_PROPS":
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    default:
      return state
  }
};

// action
export const updateProps = (data) => {
  return {
    type: "/projectList/UPDATE_PROPS",
    data: data
  }
};
